import Cookies from 'js-cookie'

const loginKey = 'LOGIN-DATA-COOKIES';
const expires = 1.5;    //天
//使用了localStorage，因为有些用户的权限较多，cookie无法存储。
export const loginData = {
  get(){
    try{
      let result = Cookies.get(loginKey);
      if(result) 
        return JSON.parse(result);
      else {
        result = localStorage.getItem(loginKey);
        let {data, ts} = JSON.parse(result);
        let now = new Date().getTime();
        if(data && ts && now - parseInt(ts) < expires * 86400000){
          return JSON.parse(data)
        }
        localStorage.removeItem(loginKey);
        return null
      }
    }catch(e){}
    return null;
  },
  set(data){
    let loginData = JSON.stringify(data);
    Cookies.set(loginKey, loginData, { expires })
    if(!Cookies.get(loginKey)){
      loginData = { data: loginData, ts: new Date().getTime() }
      localStorage.setItem(loginKey, JSON.stringify(loginData))
    }
  },
  del(){
    Cookies.remove(loginKey);
    localStorage.removeItem(loginKey);
    return true;
  }
}

export const token = {
  get(){
    try{
      let { token } = loginData.get();
      return token;
    }catch(e){}
    return null;
  }
}

export const userInfo = {
  get(){
    try{
      let { userInfo } = loginData.get();
      return userInfo;
    }catch(e){}
    return null;
  }
}

export const authList = {
  get(){
    try{
      let { authList } = loginData.get();
      return authList.split(',');
    }catch(e){}
    return null;
  }
}

const collapseKey = 'COLLAPSE_KEY'
export const collapse = {
  get(){
    try{
      let result = Cookies.get(collapseKey);
      return (result === 'true' || result == true) ? true : false;
    }catch(e){}
    return false;
  },
  set(data){
    Cookies.set(collapseKey, data ? true : false)
  },
  del(){
    return Cookies.remove(collapseKey);
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js